<template>
  <v-main class="mig-page">
    <v-container class="py-6">
      <div class="mig-hero mb-6">
        <div class="d-flex align-center flex-nowrap">
          <v-avatar size="52" class="mig-hero__icon mr-4">
            <v-icon dark size="28">mdi-swap-horizontal-bold</v-icon>
          </v-avatar>
          <div>
            <div class="text-h5 font-weight-bold white--text">ศูนย์รวมการย้ายข้อมูล</div>
            <div class="mig-hero__sub">
              รวมงานย้ายข้อมูลเข้า-ออกระบบ Loyalty ไว้ที่เดียว เลือกงานที่ต้องการแล้วทำตามขั้นตอนในหน้านั้น
            </div>
          </div>
        </div>
      </div>

      <div v-for="group in groups" :key="group.key" class="mig-group">
        <div class="d-flex align-center mb-4">
          <v-avatar size="34" :color="group.color" class="mr-3 mig-group__icon">
            <v-icon dark size="18">{{ group.icon }}</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-1 font-weight-bold">{{ group.label }}</div>
            <div class="caption grey--text text--darken-1">{{ group.desc }}</div>
          </div>
        </div>

        <v-row>
          <v-col
            v-for="item in itemsOf(group.key)"
            :key="item.id"
            cols="12"
            md="6"
          >
            <v-card class="mig-card d-flex flex-column" height="100%" outlined>
              <div class="mig-card__accent" :class="item.color" />

              <div class="mig-card__head">
                <div class="mig-card__row">
                  <v-avatar size="46" :color="item.color" class="mr-3">
                    <v-icon dark>{{ item.icon }}</v-icon>
                  </v-avatar>
                  <div class="mig-card__titles">
                    <div class="text-subtitle-1 font-weight-bold black--text">{{ item.title }}</div>
                    <div class="caption grey--text text--darken-1">{{ item.flow }}</div>
                  </div>
                  <v-chip x-small label :color="statusColor(item.status)" dark class="mig-card__chip">
                    {{ statusLabel(item.status) }}
                  </v-chip>
                </div>

                <div class="body-2 grey--text text--darken-3 mig-card__desc">{{ item.desc }}</div>

                <div v-if="item.note" class="mig-note mt-3">
                  <v-icon x-small color="orange darken-3" class="mr-1">mdi-alert-outline</v-icon>
                  {{ item.note }}
                </div>
              </div>

              <div v-if="item.steps && item.steps.length" class="mig-card__steps">
                <div class="caption grey--text text--darken-1 mb-2">ขั้นตอน</div>
                <div
                  v-for="(step, i) in item.steps"
                  :key="i"
                  class="d-flex align-start mb-2"
                >
                  <span class="mig-step" :class="item.color">{{ i + 1 }}</span>
                  <span class="caption grey--text text--darken-3">{{ step }}</span>
                </div>
              </div>

              <v-spacer />
              <v-divider />
              <v-card-actions class="mig-card__actions">
                <v-btn
                  v-if="item.to"
                  :color="item.color"
                  dark
                  depressed
                  rounded
                  small
                  @click="open(item)"
                >
                  เปิดหน้าทำงาน
                  <v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn v-else small text disabled>ยังไม่เปิดใช้งาน</v-btn>
                <v-spacer />
                <v-btn
                  v-if="item.docs"
                  small
                  text
                  :color="item.color"
                  @click="showDoc(item)"
                >
                  รายละเอียด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-dialog v-model="dialog" max-width="560">
      <v-card v-if="selected">
        <div class="mig-dialog__title">
          <v-avatar size="34" :color="selected.color" class="mr-3">
            <v-icon dark size="18">{{ selected.icon }}</v-icon>
          </v-avatar>
          <span class="text-subtitle-1 font-weight-bold">{{ selected.title }}</span>
        </div>
        <v-divider />
        <div class="mig-dialog__body">
          <div class="body-2 mb-4">{{ selected.desc }}</div>
          <div v-if="selected.docs">
            <div
              v-for="(line, i) in selected.docs"
              :key="i"
              class="d-flex align-start mb-2"
            >
              <v-icon x-small :color="selected.color" class="mr-2 mt-1">mdi-check-circle</v-icon>
              <span class="body-2 grey--text text--darken-3">{{ line }}</span>
            </div>
          </div>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text rounded @click="dialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      selected: null,
      groups: [
        {
          key: 'out',
          label: 'ย้ายออกจากระบบนี้',
          desc: 'ส่งข้อมูลของร้านไปยังระบบปลายทาง',
          icon: 'mdi-upload-outline',
          color: 'indigo'
        },
        {
          key: 'in',
          label: 'นำเข้าจากระบบอื่น',
          desc: 'ดึงข้อมูลจากผู้ให้บริการเดิมเข้ามาเป็นสมาชิกของร้าน',
          icon: 'mdi-download-outline',
          color: 'teal'
        }
      ],
      migrations: [
        {
          id: 'to-v2',
          group: 'out',
          title: 'ย้ายไป Loyalty V.2',
          flow: 'Loyalty V.1  →  Loyalty V.2',
          desc: 'ย้ายข้อมูลทั้งร้านไปยังระบบใหม่ ทั้งสมาชิก คะแนน แพ็กเกจ รางวัล และประวัติการใช้งาน',
          icon: 'mdi-rocket-launch-outline',
          color: 'indigo',
          status: 'ready',
          to: '/System/MigrateToV2',
          steps: [
            'ดูสรุปจำนวนข้อมูลที่จะย้าย',
            'สั่งย้ายแบบทดลองก่อน แล้วค่อยย้ายจริง',
            'ตามสถานะงานจนเสร็จ แล้วเทียบยอดสองระบบ'
          ],
          docs: [
            'ย้ายได้ทีละร้าน เลือกร้านจากรายการก่อนเริ่ม',
            'รองรับการย้ายซ้ำแบบเก็บเฉพาะส่วนที่เปลี่ยน ใช้ระหว่างเปิดสองระบบพร้อมกันได้',
            'ขั้นสลับ LINE ให้ชี้ระบบใหม่ แยกทำทีหลัง ไม่ได้รวมอยู่ในการย้ายข้อมูล'
          ]
        },
        {
          id: 'from-funcrowd',
          group: 'in',
          title: 'นำเข้าจาก Funcrowd',
          flow: 'ไฟล์ Excel ของ Funcrowd  →  Loyalty V.1',
          desc: 'อ่านไฟล์รายงานที่ export จาก Funcrowd แล้วสร้างเป็นสมาชิก คะแนน และแพ็กเกจในร้านที่เลือก',
          icon: 'mdi-file-excel-outline',
          color: 'teal',
          status: 'ready',
          to: '/Tool/Migration/Funcrowd',
          note: 'ต้องตรวจรายงานก่อนยืนยันทุกครั้ง ระบบจะบอกว่าใครถูกสร้างใหม่ ใครถูกนำประวัติไปต่อ',
          steps: [
            'เลือกร้านปลายทาง',
            'อัปโหลดไฟล์รายงานจาก Funcrowd',
            'ตรวจรายงานตรวจสอบ แล้วกดยืนยันนำเข้า'
          ],
          docs: [
            'ใช้เบอร์โทรศัพท์เป็นตัวจับคู่สมาชิก โดยมีไอดีไลน์ช่วยยืนยัน',
            'สมาชิกที่มีอยู่แล้วจะถูกนำประวัติไปต่อ ไม่สร้างซ้ำและไม่แก้คะแนนเดิม',
            'สมาชิกที่ยังไม่เคยผูกไลน์จะถูกสร้างไว้รอ พอลูกค้าเข้ามาครั้งแรกระบบจะผูกให้เอง',
            'สมาชิกเดิมของร้านที่ไม่มีในไฟล์ จะไม่ถูกแตะต้อง'
          ]
        }
      ]
    }
  },
  methods: {
    itemsOf (groupKey) {
      return this.migrations.filter(row => row.group === groupKey)
    },
    statusLabel (status) {
      if (status === 'ready') return 'พร้อมใช้งาน'
      if (status === 'building') return 'กำลังพัฒนา'
      return 'ปิดใช้งาน'
    },
    statusColor (status) {
      if (status === 'ready') return 'success'
      if (status === 'building') return 'warning'
      return 'grey'
    },
    open (item) {
      if (item.to) this.$router.push(item.to)
    },
    showDoc (item) {
      this.selected = item
      this.dialog = true
    }
  }
}
</script>

<style scoped>
.mig-page {
  background: #f6f7fb;
  min-height: 100%;
}

.mig-hero {
  background: linear-gradient(135deg, #3949ab 0%, #5c6bc0 55%, #26a69a 100%);
  border-radius: 16px;
  padding: 26px 30px;
  box-shadow: 0 6px 18px rgba(57, 73, 171, 0.22);
}

.mig-hero__icon {
  background: rgba(255, 255, 255, 0.18);
}

.mig-hero__sub {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  margin-top: 2px;
}

.mig-group__icon {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
}

.mig-card {
  border-radius: 14px;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.mig-card:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12) !important;
  transform: translateY(-2px);
}

.mig-card__accent {
  height: 4px;
}

.mig-note {
  background: #fff8e1;
  border-left: 3px solid #ef6c00;
  border-radius: 4px;
  color: #e65100;
  font-size: 12px;
  line-height: 1.6;
  padding: 10px 14px;
}

.mig-step {
  align-items: center;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex: 0 0 18px;
  font-size: 11px;
  height: 18px;
  justify-content: center;
  margin-right: 10px;
  margin-top: 1px;
  opacity: 0.9;
  width: 18px;
}

.mig-group {
  margin-bottom: 40px;
}

.mig-card__head {
  padding: 22px 24px 6px;
}

.mig-card__row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}

.mig-card__titles {
  flex: 1 1 150px;
  min-width: 0;
}

.mig-card__chip {
  margin-left: auto;
}

.mig-card__desc {
  line-height: 1.75;
  margin-top: 18px;
}

.mig-card__steps {
  padding: 14px 24px 18px;
}

.mig-card__actions {
  padding: 14px 20px;
}

.mig-dialog__title {
  align-items: center;
  display: flex;
  padding: 20px 24px;
}

.mig-dialog__body {
  padding: 20px 24px;
}

@media (max-width: 599px) {
  .mig-hero {
    padding: 18px 18px;
  }

  .mig-hero .text-h5 {
    font-size: 1.15rem !important;
  }

  .mig-card__head {
    padding: 18px 16px 4px;
  }

  .mig-card__steps {
    padding: 12px 16px 16px;
  }

  .mig-card__actions {
    padding: 12px 12px;
  }

  .mig-group {
    margin-bottom: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/MigrationHub.vue